import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getLocalStorageItem } from 'utils/webStorage';
import { localStorageKeys } from 'utils/constants';
import { clearLinkState, sendLoginLink } from 'state/modules/auth';
import Panel from 'components/Panel';
import LinkLoginForm from 'components/Login/LinkLoginForm';
import LinkLoginResult from 'components/Login/LinkLoginResult';

export class LinkLogin extends PureComponent {
  static propTypes = {
    email: PropTypes.string,
    clearLinkState: PropTypes.func.isRequired,
    redirectTo: PropTypes.string,
    requested: PropTypes.bool.isRequired,
    requesting: PropTypes.bool.isRequired,
    sendLoginLink: PropTypes.func.isRequired,
  };

  componentWillUnmount() {
    this.props.clearLinkState();
  }

  handleSubmit({ email }) {
    const { redirectTo, sendLoginLink } = this.props;
    const keepSession = getLocalStorageItem(localStorageKeys.keepSession) || false;
    // Encode the redirect link (if there is any) before sending the login link.
    const encodedRedirectTo = redirectTo ? encodeURIComponent(redirectTo) : undefined;
    sendLoginLink(email, keepSession, encodedRedirectTo);
  }

  handleRetry() {
    this.props.clearLinkState();
  }

  get initialFormValues() {
    const { email } = this.props;
    return { email };
  }

  render() {
    const { requested, requesting } = this.props;
    return (
      <Panel outlined>
        {
          !requested && (
            <LinkLoginForm
              initialValues={this.initialFormValues}
              loading={requesting}
              onSubmit={values => this.handleSubmit(values)}
            />
          )
        }
        {
          requested && <LinkLoginResult onRetry={() => this.handleRetry()} />
        }
      </Panel>
    );
  }
}

export default connect(state => ({
  email: state.auth.email,
  redirectTo: state.auth.redirectTo,
  requested: state.auth.requested,
  requesting: state.auth.requesting,
}), { clearLinkState, sendLoginLink })(LinkLogin);
